import { Box, Typography } from '@mui/material';
import { CornerDownLeftIcon, PlusIcon, SquareArrowOutUpRightIcon } from 'lucide-react';
import { ReactNode } from 'react';
import SsbSectionLabel from './SsbSectionLabel.tsx';

interface ResultsNextActionsProps {
  onRefineBox: () => void;
  onBuildNewBox: () => void;
  onBackToCase: () => void;
}

function NextActionCard({
  icon,
  iconColors,
  title,
  description,
  onClick,
}: {
  icon: ReactNode;
  iconColors: { background: string; color: string };
  title: string;
  description: string;
  onClick: () => void;
}) {
  return (
    <Box
      component='button'
      type='button'
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        width: '300px',
        border: '1px solid #CBD5E0',
        boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.05)',
        borderRadius: '8px',
        backgroundColor: '#fff',
        padding: '16px 18px',
        textAlign: 'left',
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        '&:hover': { borderColor: 'secondary.main' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '40px',
          height: '40px',
          flexShrink: 0,
          borderRadius: '8px',
          ...iconColors,
        }}
      >
        {icon}
      </Box>
      <Box>
        <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#1A202C' }}>{title}</Typography>
        <Typography sx={{ fontSize: '12px', color: '#718096' }}>{description}</Typography>
      </Box>
    </Box>
  );
}

function ResultsNextActions({ onRefineBox, onBuildNewBox, onBackToCase }: ResultsNextActionsProps) {
  return (
    <Box>
      <SsbSectionLabel sx={{ marginBottom: '12px' }}>Where to next</SsbSectionLabel>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
        <NextActionCard
          icon={<CornerDownLeftIcon size={18} />}
          iconColors={{ background: '#DBEAFE', color: '#1A365D' }}
          title='Refine this box'
          description='back to DEFINE · re-validates'
          onClick={onRefineBox}
        />
        <NextActionCard
          icon={<PlusIcon size={18} />}
          iconColors={{ background: '#DCFCE7', color: '#15803D' }}
          title='Build a new box'
          description='fresh box, same case'
          onClick={onBuildNewBox}
        />
        <Box sx={{ flexGrow: 1 }} />
        <NextActionCard
          icon={<SquareArrowOutUpRightIcon size={18} />}
          iconColors={{ background: '#EDF2F7', color: '#4A5568' }}
          title='Back to the case'
          description='leave the builder'
          onClick={onBackToCase}
        />
      </Box>
    </Box>
  );
}

export default ResultsNextActions;
